import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import notfound from '../images/not-found.png'
import Logo from '../images/logo.png'
import { NavLink } from 'react-router-dom';
const Notfound = ({ redirectTo404 }) => {

  return (
    <div className='bg-skyblue'>
      <Container>
            <Row>
                <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className=''>
                    <div className="d-flex flex-column min-vh-100 justify-content-center px-md-5 py-4 px-4 align-items-center">
                        <img src={Logo} width={200} className='mb-4'/>
                        <img src={notfound} width={200}/>
                        <h2 className='text-center mt-2'>PAGE NOT FOUND?</h2>
                        <p className='text-center'>Whoops, this is embarassing.<br/>
                        Looks like the page you were looking for wasn't found.</p>
                        <NavLink to='/' className='btn btn-primary mt-3'>Back To Home</NavLink>
                    </div>
                </Col>
            </Row>
      </Container>
    </div>
  );
};

export default Notfound;
